import React from "react";

const ClientsSection = () => {
    const clients = [
        { logoUrl: "/assets/pozer_logo.png" },
        { logoUrl: "/assets/logo_2.png" },
        { logoUrl: "/assets/logo_33.png" },
        { logoUrl: "/assets/logo_44.png" },
        { logoUrl: "/assets/logo_55.png" },
        { logoUrl: "/assets/logo_6.png" },
    ];

    return (
        <div className="overflow-hidden bg-transparent">
            <div className="relative w-full overflow-hidden">
                <div
                    className="flex whitespace-nowrap"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        width: "max-content",
                        animation: "marquee 15s linear infinite",
                    }}
                >
                    {/* Original logos */}
                    {clients.map((client, index) => (
                        <div key={index} className="px-4 flex-shrink-0">
                            <img
                                src={client.logoUrl}
                                alt={`Client ${index + 1} logo`}
                                className="w-24 h-24 object-contain mx-auto"
                            />
                        </div>
                    ))}
                    {/* Duplicate logos for seamless effect */}
                    {clients.map((client, index) => (
                        <div key={`duplicate-${index}`} className="px-4 flex-shrink-0">
                            <img
                                src={client.logoUrl}
                                alt={`Client Duplicate ${index + 1} logo`}
                                className="w-24 h-24 object-contain mx-auto"
                            />
                        </div>
                    ))}
                </div>
            </div>

            {/* Internal Styles for Animation (without jsx attribute) */}
            <style>
                {`
                    @keyframes marquee {
                        from {
                            transform: translateX(0);
                        }
                        to {
                            transform: translateX(-50%);
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default ClientsSection;
